'use client';

import { ColorMode } from '@/helpers';
import { text } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { DarkModeIcon, LightModeIcon } from '@onbeam/icons/business';
import { useColorModeStore } from './ColorModeButton.utils';

export const ColorModeButton = () => {
  const { colorMode, setColorMode } = useColorModeStore();

  const toggleColorMode = () =>
    setColorMode(
      colorMode === ColorMode.DARK ? ColorMode.LIGHT : ColorMode.DARK,
    );

  return (
    <Button
      type="button"
      variant="secondary"
      onClick={toggleColorMode}
      className={text({ textTransform: 'capitalize' })}
      iconLeft={
        colorMode === ColorMode.DARK ? <DarkModeIcon /> : <LightModeIcon />
      }
    >
      {colorMode.toLowerCase()}
    </Button>
  );
};
